import { throwOnError } from './utils';

export type FinancialInstitution = {
  id: string;
  code: string;
  name: string;
  name_kana: string;
};

export type FinancialInstitutionBranch = {
  id: string;
  branch_code: string;
  branch_name: string;
  branch_name_kana: string;
  bankfill: FinancialInstitution;
};

type FinancialInstitutions = {
  bankfills: FinancialInstitution[];
};

type FinancialInstitutionBranchs = {
  bankfill_branchs: FinancialInstitutionBranch[];
};

// Search financial institutions by name (partial match) XOR code (4-digit
// exact match). Passing both is a server-side error (422).
export const searchPublicFinancialInstitutions = (params: { name: string } | { code: string }) =>
  fetch(`/public/bankfills?${new URLSearchParams(params).toString()}`, {
    method: 'GET',
  })
    .then(throwOnError<FinancialInstitutions>)
    .then((resp) => resp.bankfills);

// Search branches of an institution by branch_name (partial match) XOR
// branch_code (3-digit exact match). The institution UUID is required because
// the same branch name/code can exist across different institutions.
// Note: "branchs" (sic) matches the server-side route.
export const searchPublicFinancialInstitutionBranches = (
  institutionId: string,
  params: { branch_name: string } | { branch_code: string }
) =>
  fetch(
    `/public/bankfills/${encodeURIComponent(institutionId)}/branchs?${new URLSearchParams(
      params
    ).toString()}`,
    { method: 'GET' }
  )
    .then(throwOnError<FinancialInstitutionBranchs>)
    .then((resp) => resp.bankfill_branchs);
